module.exports = __webpack_public_path__ + "img/Honigloeffel-v1-620.ea34df79.png";